/**
 * @fileoverview Tag data source and type definitions.
 */

import { TagSchema, type Tag } from '@schema/index';
import { createLookupDataSource } from './base-data-source';

export type { Tag };

export const { dataSource: tagDataSource, cache: tagCache } = createLookupDataSource({
  endpoint: 'tag',
  schema: TagSchema,
});
